export default __webpack_public_path__ + "static/media/008-goat.c2258002.svg";